module.exports = __webpack_public_path__ + "static/media/Hgienebeutel_eimer.9b57b20e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Hgienebeutel_eimer.png
// module id = 135
// module chunks = 0